import { gql } from '@apollo/client'

export const Query = gql`
  query accommodationContacts(
    $companyId: ID!,
    $accommodationId: ID!,
    $filters: AccommodationContactFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    accommodations(companyId: $companyId, filters: { idEq: $accommodationId }, first: 1) {
      nodes {
        id
        accommodationContacts(filters: $filters, after: $after, before: $before, first: $first, last: $last) {
          nodes {
            id
            name
            email
            phone
            color
            contactType
          }
          pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
        }
      }
    }
  }
`
